import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef
} from '@angular/core';
import { OffClickModule } from '@df/module-off-click/off-click.module';
/**
 * Sample usage:
 *
 *     <dropdown [value]="sort.option"
 *               (valueChange)="sort.by($event)"
 *               [options]="sort.getOptions()">
 *         <ng-template #titleTpl>{{sort.selectionLabel}}</ng-template>
 *         <ng-template #optionTpl let-option>{{option.label}}</ng-template>
 *     </dropdown>
 */
@Component({
    selector: 'dropdown',
    templateUrl: './dropdown.html',
    styleUrls: ['./dropdown.scss'],
    standalone: true,
    imports: [OffClickModule, NgTemplateOutlet],
    host: { class: 'pos-relative' },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent<T> {
    /**
     * No selection placeholder
     */
    @Input()
    placeholder?: string;
    /**
     * Selected value
     */
    @Input()
    value: T;
    /**
     * Value output
     */
    @Output()
    valueChange = new EventEmitter<T>();
    /**
     * Open state output
     */
    @Output() openChange = new EventEmitter<boolean>();
    /**
     * Options to print
     */
    @Input()
    options: T[];
    /**
     * Options alignment
     */
    @Input()
    alignOptions: 'left' | 'right' = 'right';
    /**
     * Hide dropdown arrow
     */
    @Input()
    hideIcon = false;
    /**
     * If is open
     */
    open = false;
    /**
     * Title presentation teplate
     */
    @ContentChild('titleTpl', { static: false })
    titleTpl: TemplateRef<any>;
    /**
     * Option presentation template
     */
    @ContentChild('optionTpl', { static: false })
    optionTpl: TemplateRef<any>;
    /**
     * Dependencies
     */
    constructor(private cd: ChangeDetectorRef) {}
    /**
     * Toggle state
     */
    toggle(to = !this.open) {
        this.open = to;
        this.openChange.emit(this.open);
        this.detectChanges();
    }
    pick(option: T) {
        this.toggle(false);
        this.valueChange.emit((this.value = option));
    }
    private detectChanges() {
        this.cd.detectChanges();
    }
}
